import tw from "twin.macro";

const PageHeader = tw.h1`font-bold text-2xl text-[#333333] py-5 font-roboto`;

export default PageHeader;
